import React from 'react';
import L from 'leaflet';
import { Marker, Popup } from 'react-leaflet';
import { Box } from '@material-ui/core';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('dailyPlanning');
const patientLocale = globals.getArea('patients');

const AssignmentLocationMarker = ({ assignment, orderMark }) => {
  const icon = L.divIcon({
    className: 'allocateIcons pin-mark',
    iconSize: [30, 48],
    iconAnchor: [23, 48],
    popupAnchor: [0, -55],
    html: `person_pin_circle<div class='chip'>${orderMark}</div>`,
  });
  const {
    location,
    id,
    primaryLabel,
    secondaryLabel,
    postcode,
    totalTime,
    nhsNumber,
    homeTelephone,
    mobileTelephone,
    workTelephone,
  } = assignment;
  const popupContent = (
    <div className="assignment-info">
      {[
        <div key={`assignmentMarkerPopupHeader${id}`}>
          <h5 className="popover-title">{secondaryLabel}</h5>
        </div>,
        <div className="timeslots-info-visits" key={`assignmentMarkerPopupContent${id}`}>
          <Box mt={1} display="flex" flexDirection="column">
            <Box mb={0.5}>
              {' '}
              <span>NHS No: {nhsNumber}</span>
            </Box>
            <Box mb={0.5}>
              {' '}
              <span>Postcode: {postcode}</span>
            </Box>
            <Box mb={0.5}>
              {' '}
              <span>Duration: {`${totalTime.actual.duration}${locale.getMsg('minute')}`}</span>
            </Box>
            <Box mb={0.5}>
              {' '}
              <span>
                {patientLocale.getMsg('landlinePhoneNumber')}: {homeTelephone}
              </span>
            </Box>
            <Box mb={0.5}>
              {' '}
              <span>
                {patientLocale.getMsg('mobilePhoneNumber')}: {mobileTelephone}
              </span>
            </Box>
            <Box mb={0.5}>
              {' '}
              <span>
                {patientLocale.getMsg('otherPhoneNumber')}: {workTelephone}
              </span>
            </Box>
            <Box mb={0.5}>
              {' '}
              <span>Activities: {primaryLabel}</span>
            </Box>
          </Box>
        </div>,
      ]}
    </div>
  );

  return (
    <Marker zIndexOffset={0} icon={icon} position={[location.latitude, location.longitude]}>
      <Popup>{popupContent}</Popup>
    </Marker>
  );
};

export default AssignmentLocationMarker;
